import * as buttons from 'smg/buttons';
import { AddCartItemParamsUpload, AddCartItems } from 'smg/customer-api/carts';
import { HandleRequestError } from 'smg/errors';
import { ReportValidity } from 'smg/form';
import { Relref } from '../hugo';
import * as stockitems from '../stockitems';
import * as models from 'smg/models';

declare interface myWindow extends Window {
    companyID: string;
}
declare const window: myWindow;

export default function main() {
    void stockitems.InitPrices(false);
    stockitems.InitGallery();
    stockitems.InitSeeMore();

    const $form = document.querySelector('#stock-item-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $quantity = document.querySelector('#quantity') as HTMLInputElement;
    const $addToCart = document.querySelector('#add-to-cart') as HTMLButtonElement;
    let uploadID = 0;

    switch (window.companyID) {
    case models.CompanyID.COMPANIES_SIGNATURE_COINS:
        uploadID = 1543463;
        break;
    case models.CompanyID.COMPANIES_SIGNATURE_LANYARDS:
        uploadID = 1543464;
        break;
    case models.CompanyID.COMPANIES_SIGNATURE_PATCHES:
        uploadID = 1543465;
        break;
    case models.CompanyID.COMPANIES_SIGNATURE_PINS:
        uploadID = 1543467;
        break;
    }

    $form.noValidate = true;
    $form.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.disabled = true;
        buttons.Start($addToCart);

        const params: AddCartItemParamsUpload = {
            uploadID,
            quantity: parseInt($quantity.value, 10),
            uploadLineItem: {
                name: 'Team Rally Towels',
                lineItem: 'promo items',
                type: 'Rally Towels',
                size: '11" × 18"',
                childLineItems: [],
            },
        };

        AddCartItems(params).then(() => {
            window.location.href = Relref('/cart');
        }).catch(err => {
            $fieldset.disabled = false;
            buttons.Stop($addToCart);
            HandleRequestError(err);
        });
    });
}
